module.exports = __webpack_public_path__ + "img/nebraska-jewelers.1819ec41.png";